import { trustQuotes } from '../content';
import { siteConfig } from '../../../shared/config/site';

export function TrustSection() {
  return (
    <section id="trust" className="relative bg-bone py-[calc(var(--section-padding-y)*1.5)]" aria-labelledby="trust-heading">
      <div className="mx-auto max-w-[var(--container-max)] px-[var(--section-padding-x)]">
        <div className="flex flex-col gap-6 border-b border-neutral-200 pb-12 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="section-eyebrow">Trust</p>
            <h2 id="trust-heading" className="section-title">
              What Bryanston owners say
            </h2>
          </div>
          <a
            href={siteConfig.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex min-h-[44px] flex-wrap items-baseline gap-x-4 gap-y-1 font-display text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary-500"
          >
            <span className="text-[clamp(3.75rem,9vw,6.5rem)] font-bold leading-[0.85] text-primary-600 transition-colors group-hover:text-primary-500">
              {siteConfig.ratingValue}
            </span>
            <span className="font-body text-sm text-neutral-600 underline decoration-neutral-300 underline-offset-4 transition-colors group-hover:decoration-primary-600">
              from {siteConfig.reviewCount} Google reviews
            </span>
          </a>
        </div>

        <div className="mt-4 divide-y divide-neutral-200">
          {trustQuotes.map((item) => (
            <figure key={item.name} className="grid gap-6 py-10 lg:grid-cols-[1fr_12rem] lg:gap-16">
              <blockquote className="font-display text-xl font-medium leading-relaxed text-ink sm:text-2xl">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="lg:text-right">
                <cite className="font-body text-sm not-italic font-medium text-ink">{item.name}</cite>
                <p className="mt-1 font-body text-xs text-neutral-500">{item.date}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
